/**
 * Custom Term Service
 * --------------------------------------------------------------------
 * Wraps the term-service trigger and the side-drawer pop. Mirrors the
 * pattern used in main-product.js (a host Custom Element that owns the
 * trigger, paired with the shared <side-drawer> Custom Element for the
 * pop itself).
 *
 * Usage in Liquid:
 *   <custom-term-service-list>
 *     <button class="custom_term_service_list" data-modal="..." aria-haspopup="dialog">...</button>
 *   </custom-term-service-list>
 *   <side-drawer id="..." data-name="..." data-mount-to-body>...</side-drawer>
 *
 * No jQuery. Click is delegated on the host, pop is delegated on the
 * document so newly-mounted <side-drawer> nodes are picked up too.
 */
(function () {
  if (customElements.get('custom-term-service-list')) return;

  customElements.define('custom-term-service-list', class CustomTermServiceList extends HTMLElement {
    connectedCallback () {
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback () {
      this.removeEventListener('click', this._onClick);
    }

    /**
     * Click on the trigger button → open the matching side-drawer.
     * Side-drawer handles close (button + overlay + Esc) on its own.
     */
    _onClick (evt) {
      const btn = evt.target.closest('[data-modal]');
      if (!btn) return;
      evt.preventDefault();
      const drawer = document.getElementById(btn.dataset.modal);
      if (drawer && typeof drawer.open === 'function') drawer.open(btn);
    }
  });
})();
